import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Form from 'core/form/Form';

// STYLES
import styles from './miscItems.module.scss';

// RENDER
const MiscItemsForm = ({ aryOweItem, aryOtherItem, aryBankFee }) => {
  return (
    <Form.Body>
      {aryOweItem.length
        ? aryOweItem.map((a, i) => (
            <Form.PlainText
              key={a.owe_item_id}
              label={`We Owe ${i + 1}`}
              value={a.item_price}
              schema="dollars"
              input={{
                append: <label className={styles.text}>{a.item_name}</label>
              }}
            />
          ))
        : null}
      {aryOtherItem.length
        ? aryOtherItem.map((a, i) => (
            <Form.PlainText
              key={a.sales_other_id}
              label={`Other Item ${i + 1}`}
              value={a.other_item_cost}
              schema="dollars"
              input={{
                append: <label className={styles.text}>{a.other_item}</label>
              }}
            />
          ))
        : null}
      {aryBankFee.length
        ? aryBankFee.map((a, i) => (
            <Form.PlainText
              key={a.sales_bank_fee_id}
              label={`Bank Fee ${i + 1}`}
              value={a.item_amount}
              schema="dollars"
              input={{
                append: <label className={styles.text}>{a.item_name}</label>
              }}
            />
          ))
        : null}
    </Form.Body>
  );
};

export default function MiscItems(props) {
  const { values } = useFormikContext() || {};

  const { aryOweItem = [], aryOtherItem = [], aryBankFee = [] } = values;

  return [...aryOweItem, ...aryOtherItem, ...aryBankFee].length ? (
    <Card
      title="Misc Items"
      body={<MiscItemsForm {...props} aryOweItem={aryOweItem} aryOtherItem={aryOtherItem} aryBankFee={aryBankFee} />}
    />
  ) : null;
}
